export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_SUBCATEGORIES_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_SUBCATEGORIES_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_SUBCATEGORIES_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_SUBCATEGORY_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_SUBCATEGORY_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_SUBCATEGORY_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_SUBCATEGORY_SUCCESS",
}

export interface ISubcategory {
  id: number;
  code: string | null;
  description: string | null;
  name: string;
  category: number;
  category_name: string;
  area: number;
  area_name: string;
  area_user_type: string;
}

interface NormalizedEntities {
  [key: string]: ISubcategory;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}
